module.exports = __webpack_public_path__ + "img/可装箱.ce359057.svg";